import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../../css/Common/Components/Cards/CardMain.css";
import "../../../../css/App.css";

/**
 * CardMain component renders a clickable card with a title and responsive image.
 * Navigates to the specified route when clicked.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.title - The title displayed at the top of the card.
 * @param {string} props.imgSrc - The image source for larger screens (not currently used in <img>).
 * @param {string} props.imgSrcSmall - The image source for smaller screens and default <img>.
 * @param {string} props.navigateTo - The route to navigate to when the card is clicked.
 * @param {string} [props.altText=""] - Alternative text for the image for accessibility.
 *
 * @returns {JSX.Element} The rendered CardMain component.
 */
const CardMain = ({ title, imgSrc, imgSrcSmall, navigateTo,altText =""}) => {
  const navigate = useNavigate();

  return (
    <div
      className="Card-Main"
      onClick={() => navigate(navigateTo)} // Navigate on click
    >
      <div className="Card-Main-Top">
        <h2>{title}</h2>
      </div>
      <img loading="eager" fetchPriority="high" src={imgSrcSmall} alt={altText} />
      {/* Source for smaller screens */}
      {/* <picture>
        <source srcSet={imgSrcSmall} media="(max-width: 839px)" />
      </picture> */}
      {/* Default (larger) source */}
    </div>
  );
};

export default CardMain;
